const GIFT_VARIANT_ID=53327193702689;
const THRESHOLD=1000000;
let syncing=false;
async function getCart(){const r=await fetch(window.Shopify.routes.root+'cart.js',{headers:{Accept:'application/json'}});return r.json()}
async function syncGift(){
 if(syncing)return; syncing=true;
 try{
  const cart=await getCart();
  const gift=cart.items.find(item=>Number(item.variant_id)===GIFT_VARIANT_ID);
  const qualifyingSubtotal=cart.items.filter(item=>Number(item.variant_id)!==GIFT_VARIANT_ID).reduce((sum,item)=>sum+item.final_line_price,0);
  if(qualifyingSubtotal>=THRESHOLD&&!gift){
   await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:GIFT_VARIANT_ID,quantity:1,properties:{_lt_reward:'Complimentary luggage tag'}}]})});
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }else if(qualifyingSubtotal<THRESHOLD&&gift){
   await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:gift.key,quantity:0})});
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }else if(gift&&gift.quantity!==1){
   await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:gift.key,quantity:1})});
   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }
 }catch(error){console.warn('Lucky Tony complimentary gift could not be synchronized.',error)}finally{syncing=false}
}
document.addEventListener('cart:change',()=>setTimeout(syncGift,180));
document.addEventListener('submit',event=>{if(event.target.closest('form[action*="/cart"]'))setTimeout(syncGift,700)},true);
window.addEventListener('pageshow',syncGift);
syncGift();